import React from "react";
import ReactDOM from "react-dom";
// React-Bootstrap Components
import { Dropdown } from "react-bootstrap";
// Material-UI Components
import {
    Accordion,
    AccordionSummary,
    Typography,
    AccordionDetails,
    List,
    ListItem,
    ListItemText,
    Divider,
    Link
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useStyles } from "../styles/VideoCategoryBtnStyle";

export default function VideoCategoryBtn() {
    const classes = useStyles();

    // 文法動画カテゴリー
    const grammar = window.apiVideo.grammarCategories;

    // 使い方カテゴリー
    const instruct = window.apiVideo.instructCategories;

    // トレーニングカテゴリー
    const training = window.apiVideo.trainingCategories;

    // 選択したカテゴリページへ遷移
    const handleClick = category => {
        const localUrl =
            "http://localhost:8000/materials.strail-english.jp/public/category/" +
            category;
        const productUrl =
            "https://materials.strail-english.jp/category/" + category;

        window.location.href = productUrl;
    };

    return (
        <Dropdown>
            <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                カテゴリー選択
            </Dropdown.Toggle>

            <Dropdown.Menu className={classes.dropDownMenu}>
                <div className={classes.root}>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                        >
                            <Typography className={classes.heading}>
                                アプリの使い方
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordionDetail}>
                            <Divider />
                            {instruct &&
                                instruct.map((category, index) => (
                                    <List
                                        key={index}
                                        className={classes.listRoot}
                                    >
                                        <ListItem
                                            button
                                            onClick={() =>
                                                handleClick(category)
                                            }
                                        >
                                            <ListItemText primary={category} />
                                        </ListItem>
                                    </List>
                                ))}
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                        >
                            <Typography className={classes.heading}>
                                トレーニングの進め方
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordionDetail}>
                            <Divider />
                            {training &&
                                training.map((category, index) => (
                                    <List
                                        key={index}
                                        className={classes.listRoot}
                                    >
                                        <ListItem
                                            button
                                            onClick={() =>
                                                handleClick(category)
                                            }
                                        >
                                            <ListItemText primary={category} />
                                        </ListItem>
                                    </List>
                                ))}
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                        >
                            <Typography className={classes.heading}>
                                文法動画
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordionDetail}>
                            <Divider />
                            {grammar &&
                                grammar.map((category, index) => (
                                    <List
                                        key={index}
                                        className={classes.listRoot}
                                    >
                                        <ListItem
                                            button
                                            onClick={() =>
                                                handleClick(category)
                                            }
                                        >
                                            <ListItemText primary={category} />
                                        </ListItem>
                                    </List>
                                ))}
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <div className={classes.noAccordion}>
                            <Typography className={classes.noAccordionHeading}>
                                <Link
                                    href="#"
                                    color="inherit"
                                    onClick={() =>
                                        handleClick("フォニックス動画")
                                    }
                                >
                                    フォニックス動画
                                </Link>
                            </Typography>
                        </div>
                    </Accordion>
                    <Accordion>
                        <div className={classes.noAccordion}>
                            <Typography className={classes.noAccordionHeading}>
                                <Link
                                    href="#"
                                    color="inherit"
                                    onClick={() =>
                                        handleClick("英語の基本事項")
                                    }
                                >
                                    英語の基本事項
                                </Link>
                            </Typography>
                        </div>
                    </Accordion>
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
}

if (document.getElementById("video_category_btn")) {
    ReactDOM.render(
        <VideoCategoryBtn />,
        document.getElementById("video_category_btn")
    );
}
